import { Divider } from 'antd';
import colorWheel from '../../../../Theme/ColorWheel';
import './Typography.css';

declare type TextColor = 'default' | 'reverse' | 'callOut';

interface IInfoCallOut {
    children: string| React.ReactNode;
    textColor?: TextColor;
    dataAttr?: string;
    isBold?: boolean;
    hasDivider?: boolean;
}

const InfoCallOut: React.FC<IInfoCallOut> = props => {
    const { children, textColor, dataAttr, isBold, hasDivider } = props;

    const getColor = (value: string) => {
        switch (value) {
            case 'callOut':
                return colorWheel.steelBlue;
            case 'default':
                return colorWheel.black;
            case 'reverse':
                return colorWheel.white;

            default:
                return colorWheel.black;
        }
    }

    return <>
        <h5 className='infoCallOut' style={{ fontWeight: isBold ? 600 : 400, color: getColor(textColor || 'default') }} data-infocallout={dataAttr || `infocallout`}>
            {children}
        </h5>
        {hasDivider && <Divider style={{ marginBottom: 5, marginTop: 0, borderColor: colorWheel.graniteGrey }} />}
    </>
}

export default InfoCallOut;
